import React from 'react';
import styled from 'styled-components'
import Header from './../../Resources/AppScreens/CommonComponents/Events/Navigation.svg';
import Custom0 from './../../Resources/AppScreens/CommonComponents/Events/Learn More.svg';

import Custom1 from './../../Resources/AppScreens/CommonComponents/Events/News.svg';
import Custom2 from './../../Resources/AppScreens/CommonComponents/Events/Manage Your Stay.svg';
//import { ReactComponent as Custom3 } from './../../Resources/AppScreens/CommonComponents/Hospitality/Two Buttons.svg';
//import { ReactComponent as Custom4 } from './../../Resources/AppScreens/CommonComponents/Hospitality/Property Resources.svg';
import Footer from './../../Resources/AppScreens/CommonComponents/Events/Bottom Navigation.svg';
import CampusComponents from '../../Resources/AppScreens/Preview-Features/Events';

import {Container, ScrollableContent as _ScrollableContent} from './Common';

const ScrollableContent = styled(_ScrollableContent)`
    margin-top: 0px;
    &>* {
        margin-top: 5px;
        flex-shrink: 0;
    }
`;

const EventsPreview = ({ features }) => (<Container>
    <img src={Header} style={{width: "100%"} } />
    <ScrollableContent>
        <img src={Custom0} style={{marginTop: "0px"}} />
        <img src={Custom1} />
        <img src={Custom2} />
        {features && features.map(feature => CampusComponents[feature])}
    </ScrollableContent>
    <img src={Footer} style={{ marginBottom: "0px;", marginTop: "auto", width: "100%" }} />
</Container>);

export default EventsPreview;

